
import { defineComponent, ref, computed, onMounted, onUnmounted } from "vue"
import { Actions } from "@/store/enums/StoreEnums"
import { useStore } from "vuex"
import { useRouter } from "vue-router"
import Swal from "sweetalert2/dist/sweetalert2.min.js"
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb"
import { BoxType } from "@/store/modules/BoxInfoModule"
import $ from 'jquery'
import type { DrawerProps } from 'element-plus'
import { ElMessage } from "element-plus"

export default defineComponent({
  setup() {
    onMounted(() => {
      setCurrentPageBreadcrumbs("商品列表", ["商品管理;products"])
    })

    onUnmounted(() => {
      clearPollingTimer()
    })

    const drawer = ref(false)

    const store = useStore();
    const router = useRouter();
    const tableData = ref([]);

    const formData = ref({
      product_brand: "",
      ip: "",
      is_presale: "",
      name: "",
      min_price: null,
      max_price: null
    })

    const page = ref({
      currentPage: 1,
      pageSize: 10,
      totalResult: 0
    })

    const query = () => {
      // 定义查询参数的接口
      interface QueryParams {
        product_brand: string;
        ip: string;
        is_presale: string;
        name: string;
        currentPage: number;
        pageSize: number;
        min_price?: number | null;
        max_price?: number | null;
      }

      // 创建一个新对象，过滤掉 null 值
      const queryParams: QueryParams = {
        product_brand: formData.value.product_brand,
        ip: formData.value.ip,
        is_presale: formData.value.is_presale,
        name: formData.value.name,
        currentPage: page.value.currentPage,
        pageSize: page.value.pageSize,
      }

      // 只有当价格不为 null 时才添加到查询参数中
      if (formData.value.min_price !== null) {
        queryParams.min_price = formData.value.min_price
      }
      if (formData.value.max_price !== null) {
        queryParams.max_price = formData.value.max_price
      }

      store
        .dispatch(Actions.GET_PRODUCTS, queryParams)
        .then(() => {
          tableData.value = store.getters.currentProducts;
          console.log(tableData.value)
          page.value.totalResult = store.getters.currentProductCount;
        })
        .catch(() => {
          // const [error] = Object.keys(store.getters.getErrors);
          // Swal.fire({
          //   text: store.getters.getErrors[error],
          //   icon: "error",
          //   buttonsStyling: false,
          //   confirmButtonText: "Try again!",
          //   customClass: {
          //     confirmButton: "btn fw-bold btn-light-danger",
          //   },
          // });
        });
    }

    query()

    const submitEvent = () => {
      query()
    }

    const newProduct = () => {
      router.push({ name: "product_new" })
    }

    const onPageChange = (e) => {
      page.value.currentPage = e.currentPage
      query()
    }

    const onCancel = () => {
      formData.value.product_brand = ''
      formData.value.ip = ''
      formData.value.is_presale = ''
      formData.value.name = ''
      formData.value.min_price = null
      formData.value.max_price = null
    }

    const onDownload = () => {
      store
        .dispatch(Actions.GET_DOWNLOAD_PRODUCTS)
        .then(() => {
          const blob = new Blob([store.getters.currentDownloadProducts], { type: "application/xlsx" });
          const link = document.createElement("a")
          link.href = URL.createObjectURL(blob)
          link.download = `products_${formatDate(Date().toString())}.xlsx`
          link.click();
          URL.revokeObjectURL(link.href)
        })
        .catch(() => {
          // const [error] = Object.keys(store.getters.getErrors);
          // Swal.fire({
          //   text: store.getters.getErrors[error],
          //   icon: "error",
          //   buttonsStyling: false,
          //   confirmButtonText: "Try again!",
          //   customClass: {
          //     confirmButton: "btn fw-bold btn-light-danger",
          //   },
          // });
        })
    }

    const formatDate = (date) => {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear(),
            hour = '' + d.getHours(),
            minute = '' + d.getMinutes(),
            second = '' + d.getSeconds()

        if (month.length < 2)
            month = '0' + month
        if (day.length < 2)
            day = '0' + day
        if (hour.length < 2)
            hour = '0' + hour
        if (minute.length < 2)
            minute = '0' + minute
        if (second.length < 2)
            second = '0' + second

        return [year, month, day, hour, minute, second].join('')
    }

    const onUpload = () => {
      console.log('onUpload')
      $("#btn_upload").click()
    }

    const onChange = (e) => {
      console.log('onChange')

      store
        .dispatch(Actions.UPLOAD_PRODUCTS, {
          file: e.target.files[0]
        })
        .then(() => {
          Swal.fire({
            text: "上传成功",
            icon: "success",
            buttonsStyling: false,
            confirmButtonText: "确认",
            customClass: {
              confirmButton: "btn fw-bold btn-light-primary",
            },
          })
        })
        .catch(() => {
          // const [error] = Object.keys(store.getters.getErrors);
          // Swal.fire({
          //   text: store.getters.getErrors[error],
          //   icon: "error",
          //   buttonsStyling: false,
          //   confirmButtonText: "Try again!",
          //   customClass: {
          //     confirmButton: "btn fw-bold btn-light-danger",
          //   },
          // });
        });
    }

    const product_brand_options = ref(Array<BoxType>())

    store
      .dispatch(Actions.GET_PRODUCT_BRAND_OPTIONS)
      .then(() => {
        product_brand_options.value = [{key: '', value: ''}]
        product_brand_options.value = product_brand_options.value.concat(store.getters.currentProductBrandOptions)
      })
      .catch(() => {
        // const [error] = Object.keys(store.getters.getErrors);
        // Swal.fire({
        //   text: store.getters.getErrors[error],
        //   icon: "error",
        //   buttonsStyling: false,
        //   confirmButtonText: "Try again!",
        //   customClass: {
        //     confirmButton: "btn fw-bold btn-light-danger",
        //   },
        // });
      })

    const product_ip_options = ref(Array<BoxType>())

    store
      .dispatch(Actions.GET_PRODUCT_IP_OPTIONS)
      .then(() => {
        product_ip_options.value = [{key: '', value: ''}]
        product_ip_options.value = product_ip_options.value.concat(store.getters.currentProductIpOptions)
      })
      .catch(() => {
        // const [error] = Object.keys(store.getters.getErrors);
        // Swal.fire({
        //   text: store.getters.getErrors[error],
        //   icon: "error",
        //   buttonsStyling: false,
        //   confirmButtonText: "Try again!",
        //   customClass: {
        //     confirmButton: "btn fw-bold btn-light-danger",
        //   },
        // });
      })

    const presale_options = ref(Array<BoxType>())
    presale_options.value = [{key: '', value: ''}, {key: '是', value: 'true'}, {key: '否', value: 'false'}]


    const onDelete = (id) => {
      Swal.fire({
        title: '确认删除？',
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: '确认',
        // denyButtonText: '取消',
        cancelButtonText: '取消'
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          store
            .dispatch(Actions.DELETE_PRODUCT, id)
            .then(() => {
              query()
            })
            .catch(() => {
              // const [error] = Object.keys(store.getters.getErrors);
              // Swal.fire({
              //   text: store.getters.getErrors[error],
              //   icon: "error",
              //   buttonsStyling: false,
              //   confirmButtonText: "Try again!",
              //   customClass: {
              //     confirmButton: "btn fw-bold btn-light-danger",
              //   },
              // });
            })
          // Swal.fire('Saved!', '', 'success')
        // } else if (result.isDenied) {
          // Swal.fire('Changes are not saved', '', 'info')
        }
      })
    }

    const onAbandon = (id) => {
      Swal.fire({
        title: '确认弃用？',
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: '确认',
        // denyButtonText: '取消',
        cancelButtonText: '取消'
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          store
            .dispatch(Actions.ABANDON_PRODUCT, id)
            .then(() => {
              query()
            })
            .catch(() => {
              // const [error] = Object.keys(store.getters.getErrors);
              // Swal.fire({
              //   text: store.getters.getErrors[error],
              //   icon: "error",
              //   buttonsStyling: false,
              //   confirmButtonText: "Try again!",
              //   customClass: {
              //     confirmButton: "btn fw-bold btn-light-danger",
              //   },
              // });
            })
          // Swal.fire('Saved!', '', 'success')
        // } else if (result.isDenied) {
          // Swal.fire('Changes are not saved', '', 'info')
        }
      })
    }

    const dialogVisible = ref(false)
    const current_image_url = ref('')
    const currentProductId = ref('')
    const currentRelativeBoxInfos = ref([] as any)

    const queryRelativeBoxInfo = (id) => {
      if (currentProductId.value !== id) {
        store
        .dispatch(Actions.GET_RELATIVE_BOX_INFOS, id)
        .then(() => {
          currentRelativeBoxInfos.value = store.getters.currentRelativeBoxInfos
          drawer.value = true
          currentProductId.value = id
        })
        .catch(() => {
          // const [error] = Object.keys(store.getters.getErrors);
          // Swal.fire({
          //   text: store.getters.getErrors[error],
          //   icon: "error",
          //   buttonsStyling: false,
          //   confirmButtonText: "Try again!",
          //   customClass: {
          //     confirmButton: "btn fw-bold btn-light-danger",
          //   },
          // });
        })
      } else {
        drawer.value = true
      }
    }

    const formatPrice = (price: number | string | null | undefined): string => {
      if (price === null || price === undefined) return '0.0'
      const num = Number(price)
      return isNaN(num) ? '0.0' : num.toFixed(1)
    }

    // ---- ZIP 批量上传图片 ----

    const zipInputRef = ref<HTMLInputElement | null>(null)
    const zipUploadDialogVisible = ref(false)
    const zipProgressDialogVisible = ref(false)
    const zipUploading = ref(false)
    const selectedZipFile = ref<File | null>(null)
    const uploadOverwrite = ref(false)
    const uploadIpId = ref('')
    const uploadBrandId = ref('')
    const uploadJobResult = ref<any>(null)
    const uploadStatus = ref<any>(null)
    let pollTimer: ReturnType<typeof setInterval> | null = null

    const uploadProgressPercent = computed(() => {
      if (!uploadStatus.value) return 0
      const { done, total } = uploadStatus.value
      if (!total || total === 0) return 0
      return Math.min(100, Math.round((done / total) * 100))
    })

    const uploadProgressStatus = computed(() => {
      if (!uploadStatus.value) return ''
      const s = uploadStatus.value.status
      if (s === 'completed') return 'success'
      if (s === 'failed') return 'exception'
      return ''
    })

    const uploadStatusText = computed(() => {
      if (!uploadStatus.value) return '等待处理...'
      const s = uploadStatus.value.status
      if (s === 'processing') {
        const { done, total } = uploadStatus.value
        return `处理中（${done || 0} / ${total || 0}）`
      }
      if (s === 'completed') return '处理完成'
      if (s === 'failed') return '处理失败'
      return s || '等待处理...'
    })

    const isProgressComplete = computed(() => {
      if (!uploadStatus.value) return false
      const s = uploadStatus.value.status
      return s === 'completed' || s === 'failed'
    })

    const clearPollingTimer = () => {
      if (pollTimer !== null) {
        clearInterval(pollTimer)
        pollTimer = null
      }
    }

    const onOpenZipUploadDialog = () => {
      selectedZipFile.value = null
      uploadJobResult.value = null
      uploadStatus.value = null
      uploadOverwrite.value = false
      uploadIpId.value = ''
      uploadBrandId.value = ''
      zipUploadDialogVisible.value = true
    }

    const onZipUploadDialogClosed = () => {
      selectedZipFile.value = null
      if (zipInputRef.value) {
        zipInputRef.value.value = ''
      }
    }

    const onSelectZip = () => {
      zipInputRef.value?.click()
    }

    const onZipFileChange = (e: Event) => {
      const target = e.target as HTMLInputElement
      const file = target.files?.[0]
      if (file) {
        selectedZipFile.value = file
      }
    }

    const MAX_POLL_ATTEMPTS = 300
    let pollAttempts = 0

    const pollUploadStatus = (jobId: string) => {
      clearPollingTimer()
      pollAttempts = 0
      pollTimer = setInterval(() => {
        pollAttempts++
        if (pollAttempts > MAX_POLL_ATTEMPTS) {
          clearPollingTimer()
          uploadStatus.value = { status: 'failed', error_message: '轮询超时，请刷新页面确认结果', total: 0, done: 0, results: [] }
          return
        }
        store
          .dispatch(Actions.GET_PRODUCT_IMAGES_UPLOAD_STATUS, jobId)
          .then((data: any) => {
            uploadStatus.value = data
            if (data.status === 'completed' || data.status === 'failed') {
              clearPollingTimer()
              if (data.status === 'completed') {
                query()
              }
            }
          })
          .catch(() => {
            // 忽略单次轮询网络错误，继续重试
          })
      }, 2000)
    }

    const startZipUpload = () => {
      if (!selectedZipFile.value) return
      zipUploading.value = true

      const formData = new FormData()
      formData.append('file', selectedZipFile.value)
      formData.append('overwrite', uploadOverwrite.value ? 'true' : 'false')
      if (uploadIpId.value !== '') {
        formData.append('ip_id', String(uploadIpId.value))
      }
      if (uploadBrandId.value !== '') {
        formData.append('product_brand_id', String(uploadBrandId.value))
      }

      store
        .dispatch(Actions.UPLOAD_PRODUCT_IMAGES, formData)
        .then((data: any) => {
          uploadJobResult.value = data
          zipUploadDialogVisible.value = false
          zipProgressDialogVisible.value = true
          if (data.job_id && data.process_count > 0) {
            uploadStatus.value = null
            pollUploadStatus(data.job_id)
          } else {
            // 没有需要处理的图片（全部跳过或空 ZIP）—— 直接标记完成
            uploadStatus.value = { status: 'completed', total: 0, done: 0, results: [] }
          }
        })
        .catch((err: any) => {
          ElMessage.error(err?.error_msg || err?.message || '上传失败')
        })
        .finally(() => {
          zipUploading.value = false
          if (zipInputRef.value) {
            zipInputRef.value.value = ''
          }
        })
    }

    const onCloseProgress = () => {
      clearPollingTimer()
      zipProgressDialogVisible.value = false
      uploadJobResult.value = null
      uploadStatus.value = null
    }

    return {
      tableData,
      formData,
      submitEvent,
      newProduct,
      page,
      onPageChange,
      onCancel,
      product_brand_options,
      product_ip_options,
      presale_options,
      onDownload,
      onUpload,
      onChange,
      onDelete,
      onAbandon,
      dialogVisible,
      current_image_url,
      drawer,
      queryRelativeBoxInfo,
      currentRelativeBoxInfos,
      formatPrice,
      // ZIP 批量上传图片
      zipInputRef,
      zipUploadDialogVisible,
      zipProgressDialogVisible,
      zipUploading,
      selectedZipFile,
      uploadOverwrite,
      uploadIpId,
      uploadBrandId,
      uploadJobResult,
      uploadStatus,
      uploadProgressPercent,
      uploadProgressStatus,
      uploadStatusText,
      isProgressComplete,
      onOpenZipUploadDialog,
      onZipUploadDialogClosed,
      onSelectZip,
      onZipFileChange,
      startZipUpload,
      onCloseProgress,
    }
  },
})
